import { BusinessClock } from '../../core/time/business-clock.service';
import { clockView } from '../../core/time/business-time';
import { JstDate } from '../../core/time/business-time';
import { Component, OnInit, inject } from '@angular/core';
import { RouterLink, ActivatedRoute } from '@angular/router';
import { FormsModule, NgForm } from '@angular/forms';
import { PageTitleService } from '../../core/services/page-title.service';
import { MemberService } from '../../core/services/member.service';
import { NotificationService } from '../../core/services/notification.service';
import { TransactionService } from '../../core/services/transaction.service';
import { StudioService } from '../../core/services/studio.service';
import { FormFeedback } from '../../shared/components/form-feedback.component';
import { FlashService } from '../../core/services/flash.service';
import { FlashMessageComponent } from '../../shared/components/flash-message.component';

@Component({
    selector: 'app-notification-insurance',
    imports: [RouterLink, FormsModule, FlashMessageComponent],
    template: `
<div class="animated fadeIn container-fluid">
  <div class="card">
    <div class="card-header">
      <span><i class="fa s-icon-edit"></i>&nbsp;申請</span>
    </div>
    <div class="card-body">
      <div style="height: 1px"></div>
      <form #notificationForm="ngForm" novalidate name="notificationForm" class="col-md-12" (ngSubmit)="save(notificationForm)">
        <div class="row"><app-flash-message class="col-md-12"></app-flash-message></div>
        <div class="row">
          <div class="col-md-3 text-md-right">会員ID：</div>
          <div class="col-md-3 form-group">{{ member?.memberCode }}</div>
          <div class="col-md-3 text-md-right">会員氏名：</div>
          <div class="col-md-3 form-group">{{ member?.lastName }}&nbsp;{{ member?.firstName }}</div>
          <div class="col-md-3 text-md-right">店舗：</div>
          <div class="col-md-3 form-group">{{ member?.studio?.name }}</div>
          <div class="col-md-3 text-md-right">状態：</div>
          <div class="col-md-3 form-group">
            @if (member?.status == 0) { <span>在籍中</span> }
            @if (member?.status == 1) { <span>停止</span> }
            @if (member?.status == 2) { <span>停止（除名）</span> }
          </div>
          <div class="col-md-3 text-md-right">区分コース：</div>
          <div class="col-md-3 form-group">{{ member?.studioPlan?.name }}</div>
          <div class="col-md-3 text-md-right">支払方法：</div>
          <div class="col-md-3 form-group">
            @if (member?.payment?.paymentMethod == 0) { <span>口座振替</span> }
            @if (member?.payment?.paymentMethod == 1) { <span>クレジットカード</span> }
          </div>
          <div class="col-md-3 text-md-right">ロッカー：</div>
          <div class="col-md-3 form-group">
            @if (member?.lockerNumber == null) { <span>使用しない</span> }
            @if (member?.lockerNumber != null) { <span>{{ member?.lockerNumber?.product?.name }}</span> }
          </div>
          <div class="col-md-3 text-md-right">保険適応：</div>
          <div class="col-md-3 form-group">
            @if (member?.isInsured == 0) { <span>なし</span> }
            @if (member?.isInsured == 1) { <span>あり</span> }
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-md-12">
            <div class="form-group row">
              <div class="col-md-6">
                <label class="col-form-label">保険適応</label>
                <select class="form-control" [(ngModel)]="select.isInsured" name="isInsured" required>
                  <option value="">選択してください</option>
                  @if (member?.isInsured == 0 && insuranceProduct) {
                    <option value="1">保険適応を開始する</option>
                  }
                  @if (member?.isInsured == 1) {
                    <option value="0">保険適応を終了する</option>
                  }
                </select>
              </div>
            </div>
            @if (select.isInsured == '1') {
              <div class="form-group row">
                <div class="col-md-6">
                  <label class="col-form-label">保険適応開始月</label>
                  <select class="form-control" [(ngModel)]="select.startDate" name="startDate" required>
                    <option [ngValue]="null">選択してください</option>
                    @for (opt of startDateOptionsForStart; track opt.id) {
                      <option [ngValue]="opt">{{ opt.name }}</option>
                    }
                  </select>
                </div>
              </div>
            }
            @if (select.isInsured == '0') {
              <div class="form-group row">
                <div class="col-md-6">
                  <label class="col-form-label">保険適応最終月</label>
                  <select class="form-control" [(ngModel)]="select.endDate" name="endDate" required>
                    <option [ngValue]="null">選択してください</option>
                    @for (opt of startDateOptionsForEnd; track opt.id) {
                      <option [ngValue]="opt">{{ opt.name }}</option>
                    }
                  </select>
                </div>
              </div>
            }
          </div>
        </div>
        <br /><br />
        <div class="row">
          <div class="col-md-12 text-right">
            <a [routerLink]="['/notification', memberId]" class="btn bg-close text-white"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</a>
            <button type="submit" class="btn btn-success" [disabled]="notificationForm.invalid || saving || completed || member?.status != 0"><i class="fa s-icon-finished"></i>&nbsp;申請</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
  `
})
export class NotificationInsuranceComponent implements OnInit {
  private readonly businessClock = inject(BusinessClock);
  private readonly clockContext = clockView(true);

  private pageTitleService = inject(PageTitleService);
  private memberService = inject(MemberService);
  private notificationService = inject(NotificationService);
  private flash = inject(FlashService);
  private transactionService = inject(TransactionService);
  private studioService = inject(StudioService);
  private route = inject(ActivatedRoute);

  memberId!: number;
  member: any = null;
  insuranceProduct: any = null;
  startDateOptions: any[] = [];
  select: any = { isInsured: '', startDate: null, endDate: null };
  saving = false;
  completed = false;

  private batchDay = 11;

  get startDateOptionsForStart(): any[] {
    return this.startDateOptions.filter(o => o.forStartDate);
  }

  get startDateOptionsForEnd(): any[] {
    return this.startDateOptions.filter(o => o.forEndDate);
  }

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('会員別諸届申請', 'fa fa-inbox');
    this.memberId = +this.route.snapshot.params['memberId'];
    this.batchDay = await this.transactionService.getBatchSchedule().catch(() => 11) ?? 11;
    const now = new JstDate();
    this.startDateOptions = this.getStartDateOptions(now);
    this.member = await this.memberService.getOne(this.memberId);
    if (this.member?.studio?.id) {
      this.insuranceProduct = await this.studioService.getInsuranceProduct(this.member.studio.id).catch(() => null);
    }
  }

  private getStartDateOptions(now: Date): any[] {
    const isAfter = now.getDate() >= this.batchDay;
    return Array.from({ length: 4 }, (_, i) => {
      const d = new JstDate(now.getFullYear(), now.getMonth() + i, 1);
      return {
        id: d.getFullYear() + '-' + (d.getMonth() + 1),
        name: `${d.getFullYear()}年${('0' + (d.getMonth() + 1)).slice(-2)}月`,
        date: d,
        forStartDate: isAfter ? (i === 2 || i === 3) : (i === 1 || i === 2),
        forEndDate: isAfter ? (i === 1 || i === 2) : (i === 0 || i === 1),
      };
    });
  }

  async save(form?: NgForm): Promise<void> {
    if (!await this.businessClock.confirm(this.clockContext, () => this.refreshClockDates())) return;
    if (form?.invalid || this.saving || this.completed || this.member?.status != 0) return;
    this.saving = true;
    const now = new JstDate();
    const json: any = {
      studioId: this.member.studio.id,
      memberId: this.member.id,
      requestMonth: now.getFullYear() + '-' + ('0' + (now.getMonth() + 1)).slice(-2),
      requestType: 9,
    };
    if (this.select.isInsured === '1') {
      json.startDate = this.select.startDate?.date;
    } else if (this.select.isInsured === '0') {
      const d = new JstDate(this.select.endDate?.date);
      d.setMonth(d.getMonth() + 1);
      d.setDate(0);
      json.endDate = d;
    }
    try {
      const result = await this.notificationService.upsert(json);
      if (!result) {
        this.showFeedback('danger', '諸届申請を更新できませんでした');
        return;
      }
      this.completed = true;
      this.resetInputs(form);
      this.showFeedback('success', '諸届申請を更新しました');
    } finally {
      this.saving = false;
    }
  }

  private showFeedback(type: FormFeedback['type'], text: string): void {
    // 旧版 notification-*.js の Flash.create（danger 10秒・それ以外 5秒、閉じる付き）、表示位置はフォーム先頭の <flash-message>
    this.flash.create(type, text, type === 'danger' ? 10000 : 5000);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  private resetInputs(form?: NgForm): void {
    this.select = { isInsured: '', startDate: null, endDate: null };
    form?.resetForm({ isInsured: '', startDate: null, endDate: null });
  }
  private refreshClockDates(): void {
    this.startDateOptions = this.getStartDateOptions(new JstDate());
    this.select.startDate = this.select.endDate = null;
  }

}
